export {
  default as useIsDarkBackground,
  BackgroundContext,
} from './BackgroundContext';
